module.exports = __webpack_public_path__ + "img/best-Copy.c2cd5a28.jpg";